export const CommunicationsSection = () => (
  <section>
    <h2>7. Communications</h2>

    <p>
      We engage in service and promotional communications, through e-mail,
      phone, SMS and notifications.
    </p>

    <p>
      Service Communications: We may contact you with important information
      regarding our Services. For example, we may send you notifications
      (through any of the means available to us) of changes or updates to our
      Services, billing issues, service changes, log-in attempts or password
      reset notices, etc. Our customers, and other users on the same customer
      account, may also send you notifications, messages and other updates
      regarding their or your use of the Services. Such notifications and
      messages may also be sent by them to their own customers (for example,
      invites, recordings or meeting summaries created through our Services).
      You can typically control your communications and notifications settings
      from your Volca User profile settings, or otherwise in accordance with the
      instructions included in the communications sent to you. Please note that
      you will not be able to opt-out of receiving certain service
      communications which are integral to your use (like password resets or
      billing notices).
    </p>

    <p>
      Promotional Communications: We may also notify you about new features,
      additional offerings, events, special opportunities or any other
      information we think you will find valuable, as our customer, user or
      prospect. We may provide such notices through any of the contact means
      available to us (e.g. phone, mobile or e-mail), through the Services,
      Platform or Sites, or through our marketing campaigns on any other sites
      or platforms.
    </p>

    <p>
      If you do not wish to receive such promotional communications, you may
      notify Volca at any time by sending an e-mail to:{" "}
      <a href="mailto:support@volca.ai">support@volca.ai</a>. or by following
      the "unsubscribe", "stop", "opt-out" or "change e-mail preferences"
      instructions contained in the promotional communications you receive.
    </p>
  </section>
);
